'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Question = (_temp2 = _class = function (_Component) {
  (0, _inherits3.default)(Question, _Component);

  function Question() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Question);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Question.__proto__ || (0, _getPrototypeOf2.default)(Question)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      show: false
    }, _this.toggle = function () {
      _this.setState({ show: !_this.state.show });
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Question, [{
    key: 'render',
    value: function render() {
      var show = this.state.show;

      var styles = require('./Question.scss');
      var _props = this.props,
          question = _props.question,
          answer = _props.answer;

      return _react2.default.createElement(
        'div',
        { className: styles.questionBox },
        _react2.default.createElement(
          'h2',
          { onClick: this.toggle },
          question
        ),
        show && _react2.default.createElement('div', {
          className: styles.content,
          dangerouslySetInnerHTML: { __html: answer || '' }
        })
      );
    }
  }]);
  return Question;
}(_react.Component), _class.propTypes = {
  question: _react.PropTypes.string,
  answer: _react.PropTypes.string
}, _temp2);
exports.default = Question;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/PricingPlans/Question.js
// module id = 1685
// module chunks = 0